import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

import { GrowlService } from "@lantern/app/core";

@Injectable()
export class ClipboardService {
  private windowRef: Window;

  constructor(
    @Inject(DOCUMENT) documentRef: any,
    private growlService: GrowlService
  ) {
    this.windowRef = (documentRef as Document).defaultView!;
  }

  copyToClipboard(text: string, message?: string): Promise<void> {
    return this.windowRef.navigator.clipboard
      .writeText(text)
      .then(() =>
        this.growlService.success(message || "Text copied to clipboard")
      );
  }
}
